// Shared "seen" state for website-originated leads/bookings.
// An item is NEW when created after the global last-seen mark AND not opened individually.
const LAST_SEEN_KEY = "wtd_crm_leads_last_seen";
const SEEN_ITEMS_KEY = "wtd_crm_seen_items";

export function getLastSeen() {
  let v = localStorage.getItem(LAST_SEEN_KEY);
  if (!v) {
    // First ever visit: don't flag the historical backlog as new
    v = new Date().toISOString();
    localStorage.setItem(LAST_SEEN_KEY, v);
  }
  return v;
}

function getSeenItems() {
  try {
    const arr = JSON.parse(localStorage.getItem(SEEN_ITEMS_KEY) || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function isNewLead(item) {
  return (item?.created_at || "") > getLastSeen() && !getSeenItems().includes(item?.id);
}

export function markItemSeen(id) {
  if (!id) return;
  const arr = getSeenItems();
  if (!arr.includes(id)) {
    arr.push(id);
    localStorage.setItem(SEEN_ITEMS_KEY, JSON.stringify(arr.slice(-500)));
  }
}

export function markAllSeen() {
  localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
  localStorage.setItem(SEEN_ITEMS_KEY, "[]");
}

// --- Estimate approvals (separate counter, same seen mechanism) ---
const EST_SEEN_KEY = "wtd_crm_est_approvals_last_seen";

export function getEstLastSeen() {
  let v = localStorage.getItem(EST_SEEN_KEY);
  if (!v) {
    v = new Date().toISOString();
    localStorage.setItem(EST_SEEN_KEY, v);
  }
  return v;
}

export function isNewApproval(e) {
  const at = e?.approved_at || e?.customer_response?.at || "";
  return e?.status === "approved" && at && at > getEstLastSeen() && !getSeenItems().includes(`est-${e?.id}`);
}

export function markApprovalSeen(id) {
  if (!id) return;
  markItemSeen(`est-${id}`);
}

export function markAllApprovalsSeen() {
  localStorage.setItem(EST_SEEN_KEY, new Date().toISOString());
}
